import moment from 'moment';

export default {
    chart: {
        type: 'area'
    },
    yAxis: {
        plotBands: [
            {
                from: 0,
                to: 1,
                label: {
                    text: 'Open',
                    align: 'right',
                    x: -10
                },
                zIndex: 5
            },
            {
                from: -1,
                to: 0,
                label: {
                    text: 'Closed',
                    align: 'right',
                    x: -10
                },
                zIndex: 5
            }
        ],
        tickInterval: 1,
        min: -1,
        max: 1,
        labels: {
            enabled: false
        },
        title: {
            enabled: false
        }
    },
    plotOptions: {
        area: {
            dataGrouping: {
                enabled: false
            }
        }
    },
    tooltip: {
        formatter() {
            return `${moment(this.x).format('dddd, MMM D, HH:mm')}<br>● <b>${this.y > 0 ? 'Open' : 'Closed'}</b>`;
        }
    }
};



// WEBPACK FOOTER //
// ./app/services/charting/presets/proximity.js